<template>
	<div>
		<sub-header bizCd="10"/>
		<div class="sub_visual sub10">
			<div class="container">
                <div class="sub_txt">
                    <div class="tit">보도자료</div>
                    <div class="comment">언론에 소개된 에듀윌의 다양한 소식을 만나보세요.</div>
                </div>
            </div>
		</div>
		 <div class="contents aos-all">
            <div class="container">
                <div class="sec board-list">
                    <div class="sub_tit">
                        보도 자료
                    </div>
                      <div class="con">
                        <div class="board-list">
                            <div class="list-area">
                                <div class="press-list">
                                    <ul>
                                      <li>
                                        <router-link to="/edu/newsRelease/promotionVideo/news26" class="item">
                                          <div class="thumb">
                                            <img
                                                src="//company.eduwill.net/img/promotion/202507101725063c7d7cfb-9dc9-49af-b9f7-f4ce9f5f5022.png">
                                          </div>
                                          <div class="meta">
                                            <div class="bar" style="display:none">
                                              <span class="date"></span>
                                            </div>
                                            <strong class="title">에듀윌 공인중개사 교재, 예스24 베스트셀러 1~27위 석권</strong>
                                          </div>
                                        </router-link>
                                      </li>
                                      <li>
                                        <router-link to="/edu/newsRelease/promotionVideo/news25" class="item">
                                          <div class="thumb">
                                            <img
                                                src="//company.eduwill.net/contents/img/20250605144646.jpg">
                                          </div>
                                          <div class="meta">
                                            <div class="bar" style="display:none">
                                              <span class="date"></span>
                                            </div>
                                            <strong class="title">에듀윌, AI교육기업으로 대전환 선언…“전국민 AI 성공시대 연다”</strong>
                                          </div>
                                        </router-link>
                                      </li>
                                      <li>
                                        <router-link to="/edu/newsRelease/promotionVideo/news24" class="item">
                                          <div class="thumb">
                                            <img
                                                src="//company.eduwill.net/contents/img/20250605144305.jpg">
                                          </div>
                                          <div class="meta">
                                            <div class="bar" style="display:none">
                                              <span class="date"></span>
                                            </div>
                                            <strong class="title">에듀윌, 프레임아웃과 손잡고 AI 기반 디지털 혁신 추진</strong>
                                          </div>
                                        </router-link>
                                      </li>
                                      <li>
                                        <router-link to="/edu/newsRelease/promotionVideo/news23" class="item">
                                          <div class="thumb">
                                            <img
                                                src="//company.eduwill.net/contents/img/20250605144127.jpg">
                                          </div>
                                          <div class="meta">
                                            <div class="bar" style="display:none">
                                              <span class="date"></span>
                                            </div>
                                            <strong class="title">에듀윌, 공인중개사 교재로 온라인서점 1위부터 22위까지 석권… ’수험서 시장 평정’</strong>
                                          </div>
                                        </router-link>
                                      </li>
                                      <li>
                                        <router-link to="/edu/newsRelease/promotionVideo/news22" class="item">
                                          <div class="thumb">
                                            <img
                                                src="//company.eduwill.net/contents/img/20250605142206.jpg">
                                          </div>
                                          <div class="meta">
                                            <div class="bar" style="display:none">
                                              <span class="date"></span>
                                            </div>
                                            <strong class="title">에듀윌, 넥스트챌린지·넥스트챌린지스쿨과 MOU 체결</strong>
                                          </div>
                                        </router-link>
                                      </li>
                                      <li>
                                        <router-link to="/edu/newsRelease/promotionVideo/news21" class="item">
                                          <div class="thumb">
                                            <img
                                                src="//company.eduwill.net/contents/img/20250605140923.jpg">
                                          </div>
                                          <div class="meta">
                                            <div class="bar" style="display:none">
                                              <span class="date"></span>
                                            </div>
                                            <strong class="title">에듀윌×아이헤이트플라잉버그스, AI 기반 온택트 학습 MOU 체결</strong>
                                          </div>
                                        </router-link>
                                      </li>
                                      <li>
                                        <router-link to="/edu/newsRelease/promotionVideo/news20" class="item">
                                          <div class="thumb">
                                            <img
                                                src="//company.eduwill.net/contents/img/20250605134339.jpg">
                                          </div>
                                          <div class="meta">
                                            <div class="bar" style="display:none">
                                              <span class="date"></span>
                                            </div>
                                            <strong class="title">에듀윌, HY교육과 '지방소멸 위기 극복' 위한 업무협약 체결</strong>
                                          </div>
                                        </router-link>
                                      </li>
                                      <li>
                                        <router-link to="/edu/newsRelease/promotionVideo/news19" class="item">
                                          <div class="thumb">
                                            <img
                                                src="//company.eduwill.net/contents/img/20250605133732.jpg">
                                          </div>
                                          <div class="meta">
                                            <div class="bar" style="display:none">
                                              <span class="date"></span>
                                            </div>
                                            <strong class="title">에듀윌, 폭스에듀와 MOU 체결… ‘미래 교육 판도 대변혁 시동’</strong>
                                          </div>
                                        </router-link>
                                      </li>
                                      <li>
                                        <router-link to="/edu/newsRelease/promotionVideo/news18" class="item">
                                          <div class="thumb">
                                            <img
                                                src="//company.eduwill.net/contents/img/20250605131634.jpg">
                                          </div>
                                          <div class="meta">
                                            <div class="bar" style="display:none">
                                              <span class="date"></span>
                                            </div>
                                            <strong class="title">에듀윌, 케어런츠·한국요양보호협회와 맞손… 프리미엄 요양보호사 양성 나선다!</strong>
                                          </div>
                                        </router-link>
                                      </li>
                                      <li>
                                        <router-link to="/edu/newsRelease/promotionVideo/news17" class="item">
                                          <div class="thumb">
                                            <img
                                                src="//company.eduwill.net/contents/img/20250203163010.jpg">
                                          </div>
                                          <div class="meta">
                                            <div class="bar" style="display:none">
                                              <span class="date"></span>
                                            </div>
                                            <strong class="title">에듀윌, 한국다문화청소년협회와 업무협약 체결… ‘다문화 청소년들의 성공적 자립’ 지원</strong>
                                          </div>
                                        </router-link>
                                      </li>
                                      <li>
                                        <router-link to="/edu/newsRelease/promotionVideo/news16" class="item">
                                          <div class="thumb">
                                            <img
                                                src="//company.eduwill.net/contents/img/20250131172111.jpg">
                                          </div>
                                          <div class="meta">
                                            <div class="bar" style="display:none">
                                              <span class="date"></span>
                                            </div>
                                            <strong class="title">에듀윌, EBS미디어, 메이트아이, 액티부키, 동남아시아 시장 진출 위한 공동 MOU 체결</strong>
                                          </div>
                                        </router-link>
                                      </li>
                                      <li>
                                        <router-link to="/edu/newsRelease/promotionVideo/news15" class="item">
                                          <div class="thumb">
                                            <img
                                                src="//company.eduwill.net/contents/img/20250131164717.JPG">
                                          </div>
                                          <div class="meta">
                                            <div class="bar" style="display:none">
                                              <span class="date"></span>
                                            </div>
                                            <strong class="title">에듀윌, ‘완성형 에듀테크 클러스터’ 조성에 박차</strong>
                                          </div>
                                        </router-link>
                                      </li>
                                      <li>
                                        <router-link to="/edu/newsRelease/promotionVideo/news14" class="item">
                                          <div class="thumb">
                                            <img
                                                src="//img.eduwill.net/resources/b2b/dev/images/img_report_14.png">
                                          </div>
                                          <div class="meta">
                                            <div class="bar" style="display:none">
                                              <span class="date"></span>
                                            </div>
                                            <strong class="title">에듀윌, (주)산타와 손잡고 에듀테크 속도 낸다</strong>
                                          </div>
                                        </router-link>
                                      </li>
                                      <li>
                                        <router-link to="/edu/newsRelease/promotionVideo/news13" class="item">
                                          <div class="thumb">
                                            <img
                                                src="//img.eduwill.net/resources/b2b/dev/images/img_report_13.png">
                                          </div>
                                          <div class="meta">
                                            <div class="bar" style="display:none">
                                              <span class="date"></span>
                                            </div>
                                            <strong class="title">에듀윌, 케이잡스와 상호 협력 및 파트너십 구축을 위한 <br>업무협약 체결</strong>
                                          </div>
                                        </router-link>
                                      </li>
                                      <li>
                                        <router-link to="/edu/newsRelease/promotionVideo/news12" class="item">
                                          <div class="thumb">
                                            <img
                                                src="//img.eduwill.net/resources/b2b/dev/images/img_report_12.png">
                                          </div>
                                          <div class="meta">
                                            <div class="bar" style="display:none">
                                              <span class="date"></span>
                                            </div>
                                            <strong class="title">'에듀윌 공인중개사 합격서', 판매 즉시 온라인서점 국내도서<br> 전체 베스트셀러 올라</strong>
                                          </div>
                                        </router-link>
                                      </li>
                                      <li>
                                        <router-link to="/edu/newsRelease/promotionVideo/news11" class="item">
                                          <div class="thumb">
                                            <img
                                                src="//img.eduwill.net/resources/b2b/dev/images/img_report_11.png">
                                          </div>
                                          <div class="meta">
                                            <div class="bar" style="display:none">
                                              <span class="date"></span>
                                            </div>
                                            <strong class="title">에듀윌, 감정평가사 · 노무사 신규 론칭···<br>
                                            "전문직 자격증 시장에서도 우위 잡을 것"</strong>
                                          </div>
                                        </router-link>
                                      </li>
                                      <li>
                                        <router-link to="/edu/newsRelease/promotionVideo/news10" class="item">
                                          <div class="thumb">
                                            <img
                                                src="//img.eduwill.net/resources/b2b/dev/images/img_report_10.png">
                                          </div>
                                          <div class="meta">
                                            <div class="bar" style="display:none">
                                              <span class="date"></span>
                                            </div>
                                            <strong class="title">에듀윌-육군본부, 육군 장병 취업역량 강화 '맞손'</strong>
                                          </div>
                                        </router-link>
                                      </li>


                                         <li>
                                            <router-link to="/edu/newsRelease/promotionVideo/news5" class="item">
                                                <div class="thumb">
                                                    <img src="//img.eduwill.net/resources/b2b/dev/images/img_report_05.jpg">
                                                </div>
                                                <div class="meta">
                                                    <strong class="title">에듀윌, ESG 평가서 우수 등급 획득…교육업계 최고 수준</strong>
                                                </div>
                                            </router-link>
                                        </li>
                                        <li>
                                            <router-link to="/edu/newsRelease/promotionVideo/news6" class="item">
                                                <div class="thumb">
                                                    <img src="//img.eduwill.net/resources/b2b/dev/images/img_report_06.png">
                                                </div>
                                                <div class="meta">
                                                    <strong class="title">에듀윌, 대한민국 일자리 으뜸기업에 세 번째 선정</strong>
                                                </div>
                                            </router-link>
                                        </li>
                                        <li>
                                            <router-link to="/edu/newsRelease/promotionVideo/news7" class="item">
                                                <div class="thumb">
                                                    <img src="//img.eduwill.net/resources/b2b/dev/images/img_report_07.jpg">
                                                </div>
                                                <div class="meta">
                                                    <strong class="title">'베스트셀러 1위’ 휩쓴 에듀윌 토익 교재, 수험생도 에듀윌에 눈떴다!</strong>
                                                </div>
                                            </router-link>
                                        </li>
                                        <li>
                                            <router-link to="/edu/newsRelease/promotionVideo/news8" class="item">
                                                <div class="thumb">
                                                    <img src="//img.eduwill.net/resources/b2b/dev/images/img_report_08.jpg">
                                                </div>
                                                <div class="meta">
                                                    <strong class="title">에듀윌, 사이버보안 교육 과정 신규 런칭…’보안전문가’ 양성</strong>
                                                </div>
                                            </router-link>
                                        </li>
                                        <li>
                                            <router-link to="/edu/newsRelease/promotionVideo/news9" class="item">
                                                <div class="thumb">
                                                    <img src="//img.eduwill.net/resources/b2b/dev/images/img_report_09.jpg">
                                                </div>
                                                <div class="meta">
                                                    <strong class="title">에듀윌, 국립공주대와 `부동산학과 재학생 교육 지원` 업무 협약
                                                        체결</strong>
                                                </div>
                                            </router-link>
                                        </li>
                                        <li>
                                        	<router-link to="/edu/newsRelease/promotionVideo/news1" class="item">
                                                <div class="thumb">
                                                    <img src="//img.eduwill.net/resources/b2b/dev/images/img_report_01.png">
                                                </div>
                                                <div class="meta">
                                                    <div class="bar" style="display:none">
                                                        <span class="date">22.05.24</span>
                                                    </div>
                                                    <strong class="title">에듀윌, 서울시 교육복지사업 ‘서울런’ 참여…검정고시·자격증 최신 강좌 지원</strong>
                                                </div>
                                                </router-link>
                                        </li>
                                        <li>
                                            <router-link to="/edu/newsRelease/promotionVideo/news2" class="item">
                                                <div class="thumb">
                                                    <img
                                                        src="//img.eduwill.net/resources/b2b/dev/images/img_report_02.png">
                                                </div>
                                                <div class="meta">
                                                    <div class="bar" style="display:none">
                                                        <span class="date">22.05.24</span>
                                                    </div>
                                                    <strong class="title">에듀윌, 코로나 시대
                                                        공기업 및 대기업 취업 화상교육 진행</strong>
                                                </div>
                                            </router-link>
                                        </li>
                                        <li>
                                            <router-link to="/edu/newsRelease/promotionVideo/news3" class="item">
                                                <div class="thumb">
                                                    <img
                                                        src="//img.eduwill.net/resources/b2b/dev/images/img_report_03.png">
                                                </div>
                                                <div class="meta">
                                                    <div class="bar" style="display:none">
                                                        <span class="date">22.05.24</span>
                                                    </div>
                                                    <strong class="title">에듀윌, 신한은행과
                                                        퇴직연금고객 교육솔루션 MOU 체결</strong>
                                                </div>
                                            </router-link>
                                        </li>
                                        <li>
                                            <router-link to="/edu/newsRelease/promotionVideo/news4" class="item">
                                                <div class="thumb">
                                                    <img
                                                        src="//img.eduwill.net/resources/b2b/dev/images/img_report_04.png">
                                                </div>
                                                <div class="meta">
                                                    <div class="bar" style="display:none">
                                                        <span class="date">22.05.24</span>
                                                    </div>
                                                    <strong class="title">에듀윌, 전국 대학교에
                                                        공무원 및 취업 정보지 무료 배포 진행</strong>
                                                </div>
                                            </router-link>
                                        </li>



                                    </ul>
                                </div>

                                <div class="result" style="display: none;">
                                    <p>검색 결과가 없습니다. 검색어 확인 후, 다시 시도해 주세요.</p>
                                </div>
                            </div>
                            <div class="m_hidden" style="display: none;">
                                <div class="pagination">
                                    <span class="extend prev">이전 페이지</span>
                                    <a href="#" class="page current">1</a>
                                    <a href="javascript:fnc_movePage('2');" class="page">2</a>
                                    <a href="javascript:fnc_movePage('3');" class="page">3</a>
                                    <a href="javascript:fnc_movePage('4');" class="page">4</a>
                                    <a href="javascript:fnc_movePage('5');" class="page">5</a>
                                    <a href="javascript:fnc_movePage('6');" class="page">6</a>
                                    <a href="javascript:fnc_movePage('7');" class="page">7</a>
                                    <a href="javascript:fnc_movePage('8');" class="page">8</a>
                                    <a href="javascript:fnc_movePage('9');" class="page">9</a>
                                    <a href="javascript:fnc_movePage('10');" class="page">10</a>
                                    <a href="javascript:fnc_movePage('11');" class="extend next">다음 페이지</a>
                                </div>
                            </div>

                            <div class="pc_hidden" style="display: none;">
                                <div class="pagination">
                                    <span class="extend prev">이전 페이지</span>
                                    <a href="#" class="page current">1</a>
                                    <a href="javascript:fnc_movePage('2');" class="page">2</a>
                                    <a href="javascript:fnc_movePage('3');" class="page">3</a>
                                    <a href="javascript:fnc_movePage('4');" class="page">4</a>
                                    <a href="javascript:fnc_movePage('5');" class="page">5</a>
                                    <a href="javascript:fnc_movePage('6');" class="extend next">다음 페이지</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
	<div class="float_counsel m_hidden">
        <div class="group-wrap">
            <div class="group">
                <div class="text">에듀윌과 함께<br>변화를 시작하세요.</div>
                <div class="button" @click="showCounsel('01')"><a href="javascript:;" @click="show_counsel('01')">맞춤상담신청</a></div>
                <div class="ico-hand"></div>
            </div>
        </div>
    </div>
    <div class="float_counsel_mobile pc_hidden">
		<a class="circle_counsel" @click="showCounsel('01')">맞춤<br>상담</a>
    </div>
	</div>
</template>

<script>
import SubHeader from "@/layouts/SubHeader";
import eventBus from "@/eventBus/event-bus";

export default {
	name: "MainOnlineEdu",
	components: {SubHeader},
	data() {
		return {
			swiper : ""
		}
	},
	
	computed: {
	},
	
	methods: {
		showCounsel(v) {
			eventBus.$emit("show-counsel", v);
		},
		closeCurriculum(v) {
			$('.curriculum_pop_' + v).bPopup().close();
		},
		showCurriculum(v) {
			$('.curriculum_pop_' + v).bPopup();
		}
	},
	
	created() {
	},
	beforeMount() {
	},
	mounted() {
		AOS.init({ easing: 'ease-in-out-sine' })
		
		this.swiper = new Swiper("#vi-role.swiper-container", {
	        loop: true,
	        loopFillGroupWithBlank: true,
	        navigation: {
	          nextEl: ".swiper-button-next",
	          prevEl: ".swiper-button-prev"
	        }
	    });
		
		$(".pa_slider_scroll").simplyScroll({
	        customClass:'vert',
			speed: 5,
	        pauseOnHover : true
	    });
	},
	beforeDestroy() {
	},
	destroyed() {
	}
}
</script>

<style scoped>

</style>
